module.exports = __webpack_public_path__ + "static/media/feature-insights@2x.7ae329f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-insights@2x.png
// module id = 178
// module chunks = 0